var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.86197757e-14 C12,5.86197757e-14 12,5.86197757e-14 12,5.86197757e-14 C5.37306843,5.86197757e-14 0,5.37196468 0,11.9988962 C0,18.6258278 5.37417219,23.9988962 12,23.9988962 L12,23.9988962 C18.6269316,23.9977925 24,18.6258278 24,11.9988962 C24,5.37196468 18.6269316,5.86197757e-14 12,5.86197757e-14 M12,0.96192053 L12,0.96192053 C18.0865647,0.96192053 23.0375276,5.91317618 23.0375276,11.9987954 C23.0375276,18.0844147 18.0865647,23.0369757 12,23.0369757 C5.91343529,23.0369757 0.962472406,18.0857201 0.962472406,11.9987954 C0.962472406,5.91317618 5.91343529,0.96192053 12,0.96192053",
    id: "Fill-1",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998878,7 L9.17187239,9.82711825 C7.60982451,11.3900633 7.6089273,13.9228957 9.17187239,15.4840464 C9.95244772,16.2637245 10.9752706,16.6549094 11.9989906,16.6549094 C13.0227107,16.6549094 14.047328,16.2637245 14.8288005,15.482252 C16.3908484,13.9202041 16.3899512,11.3891661 14.8288005,9.82711825 L11.9998878,7 Z",
    id: "Fill-3",
    stroke: "#727272"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home-Icon.a7065b41fe4be646db1c88edef1b16ca.svg";
export { ForwardRef as ReactComponent };